import connectedComponent from './SearchOverlayRedux';

export default connectedComponent;
